import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './EmailVerifiedSuccess.module.css';

const EmailVerifiedSuccess = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>メール認証が完了しました</h2>
      <p className={styles.desc}>ログインしてご利用を開始してください。</p>
      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={() => navigate('/login')}>
          ログインページへ
        </button>
        <button type="button" className={styles.secondary} onClick={() => navigate('/')}>トップへ戻る</button>
      </div>
    </div>
  );
};

export default EmailVerifiedSuccess;
